import React from 'react';
import styles from './ControlButton.module.scss';
import clsx from 'clsx';
import { useTranslation, Tooltip } from '@colonist/ui';
export const ControlButton = ({ icon, alt, onClick, className, tooltipContent, disabled, disableTooltip })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Tooltip, {
        content: tooltipContent,
        delay: 0,
        menuClassName: styles.tooltipMenu,
        position: "bottom",
        disabled: disableTooltip
    }, /*#__PURE__*/ React.createElement("img", {
        className: clsx(styles.controlButtonIcon, className, {
            [styles.disabled]: disabled
        }),
        onClick: onClick,
        src: icon,
        alt: t(alt)
    }));
};
